import React from 'react'
import IrregularInteraction from '../../IrregularInteraction'
import ItemImage from '../../ItemImage'
import image from '../../../assets/images/bedroom/item--rug@3x.png'

const points =
  '196.06 0 0 113 0 115.42 165.75 211.12 361.81 98.11 361.81 95.69 196.06 0'

const Rug = props => (
  <IrregularInteraction
    points={points}
    preserveAspectRatio="xMidYMin meet"
    viewBox="0 0 361.81 211.11"
    {...props}
  >
    <ItemImage src={image} />
  </IrregularInteraction>
)

Rug.propTypes = IrregularInteraction.propTypes

export default Rug



// WEBPACK FOOTER //
// ./src/components/items/bedroom/Rug.js